import React from "react";
import {Field} from "redux-form";

const radioBuilder = ({ options, ...rest }) => (
  <div className="columns is-marginless v-centered">
    {
      options.map(({ value, label }) => (
        <div className="column is-narrow">
          <div className="control has-text-centered">
            <Field {...rest} className="radio custom-radio" value={value} id={`${rest.name}_${value}`}/>
            <label htmlFor={`${rest.name}_${value}`}>{label}</label>
          </div>
        </div>
      ))
    }
  </div>
);
const selectBuilder = ({ options, ...rest }) => {
  const selectOptions = options.map(({ value, label }) => <option key={value} value={value}>{label}</option>);
  return (
    <div className="control is-expanded"><div className="select is-fullwidth"><Field {...rest}>{selectOptions}</Field></div></div>
  );
};
const defaultBuilder = ({ addon, addonType, ...rest}) => (
  <div className="field has-addons">
    {addon && addonType === 'pre' && <p className="control"><a className="button is-static">{addon}</a></p>}
    <div className="control is-expanded"><Field {...rest} /></div>
    {addon && addonType === 'post' && <p className="control"><a className="button is-static">{addon}</a></p>}
  </div>
);

export default ({ addon, addonType, ...rest}) => {
  const { component, type } = rest;
  const propsWithClass = {...rest, required: true, className: `${component}` };
  const defaultOptionValue = [{ label: "Please select one...", value: '' }];

  if (type === 'radio') {
    const DesktopView = radioBuilder;
    const MobileView = selectBuilder;
    const selectProps = {
      ...propsWithClass,
      component: 'select',
      options: defaultOptionValue.concat(propsWithClass.options)
    };

    return (
      <div>
        <div className="is-hidden-mobile"><DesktopView {...propsWithClass} /></div>
        <div className="is-hidden-tablet"><MobileView {...selectProps} /></div>
      </div>
    );
  } else {
    if (component === 'select') {
      return selectBuilder(propsWithClass);
    } else {
      return defaultBuilder({...propsWithClass, addon, addonType});
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/input-field/index.js